import { useEffect, useState, React, Fragment } from "react";
import '../css/PainelAPI.css';
import NavBar from "./NavBar";
import { obterNomeGrupoPorIdGia } from "../js/grupoFarmacia";
import TipoAPI from '../js/tipoAPI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import Loading from "./loading";


function PainelAPI(props) {
    const [dados, setDados] = useState([]);
    const [ordenacao, setOrdenacao] = useState({ coluna: 'GIA', direcao: 'asc' });
    const [paginaCarregada, setPaginaCarregada] = useState(false);
    const [query, setQuery] = useState('');

    const SortIcon = ({ coluna }) => {
        if (ordenacao.coluna === coluna) {
            return ordenacao.direcao === 'asc' ? (
                <FontAwesomeIcon icon={faSortUp} className="px-2 text-sm " style={{ color: '#f5f9ff' }} />
            ) : (
                <FontAwesomeIcon icon={faSortDown} className="px-2 text-sm " style={{ color: '#f5f9ff' }} />
            );
        }
        return null;
    };


    const ordenarPorColuna = (coluna) => {
        setDados((dadosAtuais) => {
            const novosDados = [...dadosAtuais];
            const direcao = coluna === ordenacao.coluna && ordenacao.direcao === "asc" ? "desc" : "asc";

            const dadosOrdenados = novosDados.map((item, index) => {
                let valor;

                switch (coluna) {
                    case "GIA":
                        valor = item._id
                        break;
                    case "Nome":
                        valor = item.nomeFantasia;
                        break;
                    case "Empresa API":
                        valor = item.apis.map(api => api.descricao).sort().join(", ");
                        break;
                    case "Grupo":
                        valor = obterNomeGrupoPorIdGia(item._id);
                        break;
                    default:
                        break;
                }

                return { index, valor };
            });

            dadosOrdenados.sort((a, b) => {
                if (typeof a.valor === 'string' && typeof b.valor === 'string') {
                    return direcao === 'asc' ? a.valor.localeCompare(b.valor) : b.valor.localeCompare(a.valor);
                } else {
                    return direcao === 'asc' ? a.valor - b.valor : b.valor - a.valor;
                }
            });

            const dadosOrdenadosFiltrados = dadosOrdenados.map(item => novosDados[item.index]);

            setOrdenacao({ coluna, direcao });

            return dadosOrdenadosFiltrados;
        });
    };


    useEffect(() => {
        const tokenAcesso = process.env.REACT_APP_MONGO_token;
        const requestOptions = {
            // method: 'GET',
            headers: { token: tokenAcesso }
        };

        fetch(process.env.REACT_APP_API_USAAPI, requestOptions)
            .then(dados => dados.json())
            .then(data => {
                setDados(data);
                setPaginaCarregada(true);

                ordenarPorColuna('Nome');
            })
            .catch(err => console.log(err))
    }, [])


    if (!paginaCarregada) {
        return <Loading />;
    }

    let cabecalhoTabela = ['GIA', 'Nome', 'Grupo', 'Empresa API', 'API', 'PAGANDO'];

    let totalResultado = 0;

    if (dados) {
        const dadosFiltrados = dados.filter((item) => {
            return (item.apis.some(
                (recurso) => item._id)
            )

        })
        return (
            <div >
                <div className="menu">
                    <NavBar />
                    <div className="max-w-screen-2xl  ml-20 mr-1 flex-1">
                        <div className="flex flex-col pb-4 " >
                        </div>
                        <div className="mb-3 xl:w-25">
                            <div className="relative mt-4 mb-4 flex w-full flex-wrap items-stretch">
                                <input
                                    type="search"
                                    className="relative m-0 block flex-auto rounded border border-solid border-neutral-300 
                                bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6]
                                 text-neutral-100 outline-none transition duration-200 ease-in-out focus:z-[3] 
                                 focus:border-primary focus:text-neutral-100 focus:shadow-[inset_0_0_0_1px_rgb(59,113,202)] focus:outline-none
                                 dark:border-neutral-600
                                 dark:text-neutral-200
                                dark:placeholder:text-neutral-200 dark:focus:border-primary"
                                    placeholder="Pesquisa"
                                    aria-label="Pesquisa"
                                    aria-describedby="button-addon2"
                                    onChange={(e) => setQuery(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="max-w-screen-2xl">
                            <table style={{ backgroundColor: '#27293D' }} className="min-w-full divide-y  divide-gray-200 overflow-x-auto ">
                                <thead>
                                    <tr style={{ backgroundColor: '#27293D' }}>
                                        {cabecalhoTabela.map((cabecalho, index) => (
                                            <th
                                                key={index}
                                                style={{ backgroundColor: '#27293D' }}
                                                className="px-3 py-2 text-white"
                                                onClick={() => ordenarPorColuna(cabecalho)}
                                            >
                                                {cabecalho} <SortIcon coluna={cabecalho} />
                                            </th>

                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-black">
                                    {dadosFiltrados.map((item, index) => {
                                        const grupo = (item.mysqlInfo && item.mysqlInfo.length > 0 && item.mysqlInfo[0].grupo)
                                            ? item.mysqlInfo[0].grupo.toUpperCase()
                                            : '';
                                        const idgia = item._id;
                                        const combinacoesUnicas = new Set();
                                        return (
                                            <Fragment key={index}>
                                                {item.apis
                                                    .filter(api => api.descricao !== '' && item._id !== 137)
                                                    .map((api, apiIndex) => {

                                                        const combinacaoUnica = `${idgia}-${api.descricao}`;
                                                        const isNotas = (query.toLowerCase().includes('notas') && api.notas === '1');
                                                        const isVendaCliente = (query.toLowerCase().includes('vendaCliente') && api.vendaCliente === '1');
                                                        const isProdutoEstoque = (query.toLowerCase().includes('produtoestoque') && api.produtoestoque === '1');
                                                        const isFarmaciasAPP = (query.toLowerCase().includes('farmaciasapp') && api.farmaciasAPP === '1');
                                                        const isFinanceiro = (query.toLowerCase().includes('financeiro') && api.financeiro === '1');
                                                        const isPreVenda = (query.toLowerCase().includes('prevenda') && api.preVenda === '1');
                                                        const isPrecificacaoDiferenciada = (query.toLowerCase().includes('precificacaodiferenciada') && api.precificacaoDiferenciada === '1');
                                                        const isPagando = api.contratada;
                                                        if (
                                                            (!query ||
                                                                (item._id ?? '').toString().includes(query.toLowerCase()) || (item.nomeFantasia ?? '').toLowerCase().includes(query.toLowerCase()) ||
                                                                api.descricao.toLowerCase().includes(query.toLowerCase())
                                                                || isNotas || isProdutoEstoque || isFarmaciasAPP || isFinanceiro || isPreVenda || isPrecificacaoDiferenciada) &&
                                                            !combinacoesUnicas.has(combinacaoUnica)
                                                        ) {
                                                            combinacoesUnicas.add(combinacaoUnica);
                                                            totalResultado += 1;
                                                            return (
                                                                <tr key={`${index}-${apiIndex}`} style={{ backgroundColor: '#27293D' }}>
                                                                    <td style={{ backgroundColor: '#27293D' }} nowrap="nowrap" className="px-3 py-2 text-white">
                                                                        {idgia}
                                                                    </td>
                                                                    <td style={{ backgroundColor: '#27293D' }} className="px-3 py-2 text-white">
                                                                        {item.nomeFantasia}
                                                                    </td>
                                                                    <td style={{ backgroundColor: '#27293D' }} className="px-3 py-2 text-sm leading-5 font-semibold text-white">
                                                                        {grupo}
                                                                    </td>
                                                                    <td style={{ backgroundColor: '#27293D' }}>
                                                                        <td style={{ backgroundColor: '#27293D' }} nowrap="nowrap" className="text-sm font-medium px-1 text-gray-900">
                                                                            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full text-green-50`}>

                                                                                {api.descricao}
                                                                            </span>
                                                                        </td>
                                                                    </td>
                                                                    <TipoAPI api={api} />
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            id="pagando"
                                                                            name="pagando"
                                                                            checked={isPagando}
                                                                            readOnly />


                                                                    </td>
                                                                </tr>
                                                            );
                                                        }

                                                        return null;
                                                    })}

                                            </Fragment>


                                        );
                                    })}

                                </tbody>


                            </table>
                            <p className="text-white">Resultados Encontrados: {totalResultado}</p>
                        </div>

                    </div>
                </div>

            </div>


        );
    } else {
        return <div>falha ao carregar</div>;
    }



};


export default PainelAPI;